import { render, staticRenderFns } from "./Planos.vue?vue&type=template&id=22e6cbdc&scoped=true"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"
import style0 from "./Planos.vue?vue&type=style&index=0&id=22e6cbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6cbdc",
  null
  
)

export default component.exports